const controller = function(component){
    var self = this;

    this.init = function(){
        //Setup answers container
        self.clear();

        //Setup enable/disable switches
        var disabled = {};
        for(let g=0; g<component.question.config.groups.length; g++){
            var group = component.question.config.groups[g];

            disabled[group.id] = {};

            for(let i=0; i<group.inputs.length; i++){
                var input = group.inputs[i];
                disabled[group.id][input.id] = input.disabled ? true: false;
            }
        }
        component.disabled = disabled;      
        
        //Setup enable other
        self.clearOther();
    }

    this.setValue = function(group_id, valueArray){
        if( group_id && valueArray && typeof valueArray=='object' ){
            component.value[group_id] = valueArray;
        }else{
            console.error("setValue Error: ",{
                group_id: group_id,
                value: value
            })
        }
    }

    this.value_action = function(){
        return new Promise((resolve, reject)=>{
            var answers = component.value;
            
            for(let group_id in answers){
                var selected = answers[group_id];
                var last = selected[selected.length-1];
                var last_config = last ? component.get_config(group_id, last) : null;

                if(last && last_config.input.exclusive===true){
                //CLEAR NON-EXCLUSIVE
                    if(selected.length!=1){
                        component.value[group_id] = [last];
                        break;
                    }
                }else if(last && last_config.input.exclusive===false){
                    //CLEAR EXCLUSIVE
                    var sans_exclusive = [];
                    for(let i=0; i<selected.length; i++){
                        var value = selected[i];
                        var input_config = component.get_config(group_id, value);
                        if(input_config.input.exclusive===false){sans_exclusive.push(value)}                            
                    }
                    if(sans_exclusive.length != selected.length){
                        component.value[group_id] = sans_exclusive;
                        break;
                    }
                }
            }
            

            
            var enableOther = component.enableOther;
            var enableThese = {};
            for(let group_id in enableOther){
                enableThese[group_id] = {};
                var group = enableOther[group_id];
                for(let input_value in group){
                    enableThese[group_id][input_value] = false;
                    var config = component.get_config(group_id, input_value);
                                            
                    for(let i=0; i<component.value[group_id].length; i++){
                        var value = component.value[group_id][i];
                        if( (value == input_value) ){
                            if( (config.input.other===true) ){
                                enableThese[group_id][input_value] =  true;
                            }
                            break;
                        }
                    }
                }
            }
            component.enableOther = enableThese;

            var other = component.other;
            for(let group_id in enableThese){
                var group = enableThese[group_id];
                for(let input_value in group){
                    var enabled = enableThese[group_id][input_value];
                                            
                    if(enabled===false){
                        other[group_id][input_value] = null;
                    }
                }
            }                
            resolve();
        })
    }

    this.clear = function(group_id, value){
        if(group_id && value){
            var checked = [];
            for(let i=0; i<component.value[group_id].length; i++){
                var checked_value = component.value[group_id][i];
                if(checked_value!=value){
                    checked.push(checked_value);
                }
            }
            component.value[group_id] = checked;
            self.clearOther(group_id, value);
        }else{
            var value = {}
            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
    
                value[group.id] = [];
            }
            component.value = value;
            self.clearOther();
        }
        
    }

    this.setDisable = function(state, group_id, input_id){
        var config = component.get_config(group_id, input_id);
        var value = config.input.value;
        if(state===true){
            self.clear(group_id, value);
        }
        component.disabled[group_id][input_id] = state;
    }
    
    this.setDisableNonSelected = function(group_id){
        let groupSelected = component.question.value[group_id];
        let disabled = component.disabled[group_id];
        for(let input_id in disabled){
            component.disabled[group_id][input_id] = groupSelected.includes(parseInt(input_id)) === false;
        }
    }
    
    this.resetDisabled = function(group_id){
        let disabled = component.disabled[group_id];
        for(let input_id in disabled){
            if (component.disabled[group_id][input_id]===true){
                component.disabled[group_id][input_id] = false;
            }
        }        
    }

    this.clearOther = function(group_id, value){
        if(group_id && value){
            component.other[group_id][value] = null;
            component.enableOther[group_id][value] = false;
        }else{
            //Setup 'other' fields
            var other = {}
            var enableOther = {}
            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
    
                other[group.id] = {};
                enableOther[group.id] = {};
                for(let i=0; i<group.inputs.length; i++){
                    var input = group.inputs[i];
                    enableOther[group.id][input.id] = false;
                    other[group.id][input.id] = null;
                }
            }
            component.other = other;
            component.enableOther = enableOther;
        }
    }

    this.validate = function(){
        var valid = false;
        var enableOther = component.enableOther;
                
        for(let group_id in component.value){
            let answers = component.value[group_id];
            if (component.question.config.max_num_picks!==undefined && component.question.config.min_num_picks!==undefined){
                let max_num_picks = component.question.config.max_num_picks !== 0 ? component.question.config.max_num_picks : component.question.config.groups[0].inputs.length;
                valid = component.question.config.min_num_picks <= answers.length && answers.length <=max_num_picks;
                if (!valid){
                    break;
                }
            }

            for(let i=0; i<answers.length; i++){
                var value = answers[i];
                var other = component.other[group_id][value];
                var enabled = enableOther[group_id][value];

                valid = enabled===false || other!=null && other.length>0;
                if(valid===false){
                    break;
                }
            }

        }
        
        return valid;
    }

    this.init();    
}

export default controller;